import { render, staticRenderFns } from "./product-konica-minolta.vue?vue&type=template&id=5e94d12d&"
import script from "./product-konica-minolta.vue?vue&type=script&lang=js&"
export * from "./product-konica-minolta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports